var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31122 1.49416C8.25317 1.43596 8.1842 1.38978 8.10826 1.35827C8.03233 1.32677 7.95093 1.31055 7.86872 1.31055C7.78651 1.31055 7.70511 1.32677 7.62918 1.35827C7.55325 1.38978 7.48428 1.43596 7.42622 1.49416L3.27122 5.64916C3.22487 5.69542 3.1881 5.75037 3.16301 5.81085C3.13792 5.87134 3.125 5.93618 3.125 6.00166C3.125 6.06715 3.13792 6.13199 3.16301 6.19248C3.1881 6.25296 3.22487 6.30791 3.27122 6.35416L7.42622 10.5092C7.67122 10.7542 8.06622 10.7542 8.31122 10.5092C8.55622 10.2642 8.55622 9.86916 8.31122 9.62416L4.69122 5.99916L8.31622 2.37416C8.55622 2.13416 8.55622 1.73416 8.31122 1.49416Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.05452932298cd021e593d6099f2baa73.svg";
export { ForwardRef as ReactComponent };